import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const API = process.env.REACT_APP_BACKEND_URL || '';

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing (React StrictMode)
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Extract session_id from URL hash
        const hash = window.location.hash;
        const sessionIdMatch = hash.match(/session_id=([^&]+)/);
        
        if (!sessionIdMatch) {
          console.error('No session_id found in URL');
          navigate('/login');
          return;
        }

        const sessionId = sessionIdMatch[1];
        console.log('Processing OAuth session_id:', sessionId);

        // Exchange session_id for session_token via backend
        const response = await fetch(`${API}/api/auth/session`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          credentials: 'include',
          body: JSON.stringify({ session_id: sessionId }),
        });

        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          console.error('Session exchange failed:', errorData);
          navigate('/login');
          return;
        }

        const data = await response.json();
        console.log('Session exchange successful:', data);

        // Store the session token for backup (cookie is primary)
        if (data.session_token) {
          sessionStorage.setItem('session_token', data.session_token);
        }

        // Check if there's a pre-login quiz result to persist
        const preLoginQuizResult = sessionStorage.getItem('preLoginQuizResult');
        if (preLoginQuizResult) {
          try {
            const quizData = JSON.parse(preLoginQuizResult);
            await fetch(`${API}/api/quick-quiz/submit`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${data.session_token}`
              },
              credentials: 'include',
              body: JSON.stringify({
                stage_key: quizData.stage_key,
                stage_name: quizData.stage_name,
                stage_level: quizData.stage_level,
                direction: quizData.direction,
                answers: quizData.answers
              })
            });
            sessionStorage.removeItem('preLoginQuizResult');
            console.log('Pre-login quiz result saved successfully');
          } catch (quizError) {
            console.error('Error saving pre-login quiz result:', quizError);
          }
        }

        // Clean up URL and navigate to dashboard
        window.history.replaceState({}, document.title, '/dashboard');
        navigate('/dashboard', { replace: true });

      } catch (error) {
        console.error('Auth callback error:', error);
        navigate('/login');
      }
    };

    processAuth();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-black flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-yellow-500 mx-auto mb-6"></div>
        <h2 className="text-xl font-semibold text-white mb-2">Completing Sign In...</h2>
        <p className="text-gray-400">Please wait while we set up your account</p>
      </div>
    </div>
  );
};

export default AuthCallback;
